<template>
  <div>
    <div class="discountModule">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <!-- 限时秒杀 -->
        <div class="module module1"
             v-if="seckillList.length!=0">
          <div class="navBox">
            <div class="title1">限时秒杀<span v-if="seckillType==0">(敬请期待)</span></div>
            <div class="timeBox"
                 v-if="seckillType==1&&(seckillInfo1||seckillInfo2)">
              <div class="box1"
                   :class="tabIndex==1?'check':''"
                   v-if="seckillInfo1"
                   @click="changeSeckill(1)">
                <div class="time">{{ seckillInfo1.startTime }}</div>
                <div class="countDown">
                  <el-statistic :value="seckillInfo1.killFlag==0?seckillInfo1.startCountDown:seckillInfo1.endCountDown"
                                format="HH:mm:ss"
                                time-indices
                                @finish="onFinish"
                                :title="seckillInfo1.killFlag==0?'秒杀未开始':'正在秒杀'">
                    <template slot="prefix">
                      <span class="word">{{ seckillInfo1.killFlag==0?'距开始':'距结束' }}</span>
                    </template>
                  </el-statistic>
                </div>
              </div>
              <div :class="tabIndex==1?'box2':'box2_2'"></div>
              <div @click="changeSeckill(2)">
                <div class="box3"
                     :class="tabIndex==2?'check':''"
                     v-if="seckillInfo2">
                  <div class="time">{{ seckillInfo2.startTime }}</div>
                  <div class="lable">即将开始</div>
                </div>
                <div class="box3"
                     :class="tabIndex==2?'check':''"
                     v-else>
                  <div class="time">敬请期待</div>
                </div>
              </div>
            </div>
            <div class="more"
                 @click="jumpPage(1)">
              <span class="word">更多</span>
              <div class="icon">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="goodBox">
            <div class="list">
              <div class="item"
                   v-for="(item,i) in seckillList"
                   :key="i"
                   @click="jumpDetail(item,1)">
                <img :src="item.mainImg"
                     class="img"
                     alt="">
                <div class="info">
                  <div class="name">{{ item.spuName }}</div>
                  <div class="box">
                    <div class="lable"><span class="txt">秒杀价</span></div>
                    <div class="price">￥<span class="txt">{{ (Number(item.secondPrice)/100).toFixed(2) }}</span></div>
                    <div class="price2">￥{{ (Number(item.salePrice)/100).toFixed(2) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 限量特惠 -->
        <div class="module module2"
             v-if="specialList.length!=0">
          <div class="navBox">
            <div class="title2">限量特惠<span v-if="specialType==0">(敬请期待)</span></div>
            <div class="timeBox"
                 v-if="specialType==1">
              <div class="box1 box4 check ">
                <div class="countDown">
                  <el-statistic :value="specialInfo.countdown"
                                format="DD天HH小时mm分钟ss秒"
                                time-indices
                                @finish="onFinish2">
                    <template slot="prefix">
                      <span class="word">活动距结束</span>
                    </template>
                  </el-statistic>
                </div>
              </div>
            </div>
            <div class="more"
                 @click="jumpPage(2)">
              <span class="word">更多</span>
              <div class="icon">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="goodBox">
            <div class="list">
              <div class="item"
                   v-for="(item,i) in specialList"
                   :key="i"
                   @click.stop="jumpDetail(item,2)">
                <img :src="item.productSpu.picUrl"
                     class="img"
                     alt="">
                <div class="info">
                  <div class="name">{{ item.productSpu.name }}</div>
                  <div class="box">
                    <div class="lable"><span class="txt">特惠价</span></div>
                    <div class="price">￥<span class="txt">{{ (Number(item.specialPrice)/100).toFixed(2) }}</span></div>
                    <div class="price2">￥{{ (Number(item.price)/100).toFixed(2) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 特价拼团 -->
      <div class="module3">
        <div class="top">
          <div class="left">特价拼团</div>
          <div class="right">
            <div class="center">
              <div class="box"></div>
            </div>
            <div class="tabBox">
              <div class="tabs">
                <div class="tab"
                     v-for="(v,i) in groupTabs"
                     :key="i"
                     @click="changeGroup(v,i)">
                  <div class="word">{{ v.name }}</div>
                  <div class="line"
                       :class="groupIndex==i?'line1':'line2'"></div>
                </div>
              </div>
              <div class="more"
                   @click="jumpPage(3)">
                <span class="word">更多</span>
                <div class="icon">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="goods">
          <div class="out">
            <div class="list">
              <div class="item"
                   v-for="(item,i) in groupList"
                   :key="i"
                   @click.stop="jumpDetail(item,3)">
                <img :src="item.mainImg"
                     class="img"
                     alt="">
                <div class="info">
                  <div class="name">{{ item.name }}</div>
                  <div class="box1">
                    <div class="lable1">自营</div>
                    <div class="lable2"
                         v-if="item.grouponSuccessType == 1">{{item.lowestGroupNum}}人团</div>
                  </div>
                  <div class="box2">
                    <div class="price">￥<span class="txt">{{ (Number(item.singlePrice)/100).toFixed(2) }}</span></div>
                    <div class="price2">￥{{ (Number(item.marketPrice)/100).toFixed(2) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'discountModule',
  data () {
    return {
      deadline2: Date.now() + 1000 * 60 * 60 * 8,
      tabIndex: 1,
      seckillType: 1,
      seckillInfo1: '',
      seckillInfo2: '',
      seckillList: [],

      specialInfo: {},
      specialList: [],
      specialType: 1,

      groupTabs: [],
      groupIndex: 0,
      groupList: [],
      groupType: 0,

      list1: [{
        price: 3900,
        specialPrice: 3200,
        productSpu: {
          name: '味滋源 好久梅见桶装320g 蜜饯果干混合口味梅子青梅话梅休闲零食',
          picUrl: 'https://img13.360buyimg.com/n12/jfs/t1/241175/27/6789/231744/660a1245F14f539f8/f39335e6843acc95.jpg'
        }
      }, {
        price: 5757,
        specialPrice: 4899,
        productSpu: {
          name: '周黑鸭 好多肉肉礼盒500g 甜辣鸭舌鸭脖鸭掌 零食大礼包 真空独立小包',
          picUrl: 'https://img13.360buyimg.com/n12/jfs/t1/226925/28/3291/243556/6557583bF7eb63121/8ad77e28434c1bb1.png'
        }
      }, {
        price: 3656,
        specialPrice: 2986,
        productSpu: {
          name: '旺旺 零食大礼包 600g 混合袋装 休闲零食送女友礼物',
          picUrl: 'https://img13.360buyimg.com/n12/jfs/t1/223639/31/17932/195890/6375907bE62d4b60b/3d745d390c339395.jpg'
        }
      }],
      list2: [{
        salePrice: 3900,
        secondPrice: 3200,
        spuName: '味滋源 好久梅见桶装320g 蜜饯果干混合口味梅子青梅话梅休闲零食',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/241175/27/6789/231744/660a1245F14f539f8/f39335e6843acc95.jpg'
      }, {
        salePrice: 5757,
        secondPrice: 4899,
        spuName: '周黑鸭 好多肉肉礼盒500g 甜辣鸭舌鸭脖鸭掌 零食大礼包 真空独立小包',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/226925/28/3291/243556/6557583bF7eb63121/8ad77e28434c1bb1.png'
      }, {
        salePrice: 3656,
        secondPrice: 2986,
        spuName: '旺旺 零食大礼包 600g 混合袋装 休闲零食送女友礼物',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/223639/31/17932/195890/6375907bE62d4b60b/3d745d390c339395.jpg'
      }],
      list3: [{
        marketPrice: 3900,
        groupPrice: 3200,
        name: '味滋源 好久梅见桶装320g 蜜饯果干混合口味梅子青梅话梅休闲零食',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/241175/27/6789/231744/660a1245F14f539f8/f39335e6843acc95.jpg'
      }, {
        marketPrice: 5757,
        groupPrice: 4899,
        name: '周黑鸭 好多肉肉礼盒500g 甜辣鸭舌鸭脖鸭掌 零食大礼包 真空独立小包',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/226925/28/3291/243556/6557583bF7eb63121/8ad77e28434c1bb1.png'
      }, {
        marketPrice: 3656,
        groupPrice: 2986,
        name: '旺旺 零食大礼包 600g 混合袋装 休闲零食送女友礼物',
        mainImg: 'https://img13.360buyimg.com/n12/jfs/t1/223639/31/17932/195890/6375907bE62d4b60b/3d745d390c339395.jpg'
      }],
    };
  },

  mounted () {
    this.getSeckill()
    this.getSpecial()
    this.getGroup()
  },

  methods: {
    // 倒计时结束
    onFinish (val) {
      if (val) {
        this.getSeckill()
      }
    },
    onFinish2 (val) {
      if (val) {
        this.getSpecial()
      }
    },
    // 切换秒杀场次
    changeSeckill (type) {
      if (type == this.tabIndex) {
        return
      }
      if (type == 2 && !this.seckillInfo2) {
        return
      }
      this.tabIndex = type
      if (type == 1) {
        this.seckillList = !this.seckillInfo1.data ? this.list2 : this.seckillInfo1.data
      } else {
        this.seckillList = !this.seckillInfo2.data ? this.list2 : this.seckillInfo2.data
      }
      this.$forceUpdate()
    },
    // 切换拼团活动
    changeGroup (v, i) {
      if (this.groupIndex == i) { return }
      this.groupIndex = i
      this.$loading()
      this.getGroupGoodsList(1)
    },
    // 查看更多
    jumpPage (type) {
      if (type == 1 && this.seckillType != 0) {
        this.$store.dispatch('saveSeckillInfo', '')
        this.$router.push({
          name: 'seckillList',
        })
      } else if (type == 2 && this.specialType != 0) {
        this.$store.dispatch('saveSpecialInfo', '')
        this.$router.push({
          name: 'specialList',
        })
      } else if (type == 3 && this.groupType != 0) {
        // this.$store.dispatch('saveGroupInfo', '')
        this.$router.push({
          name: 'groupList',
        })
      } else {
        return this.$message.warning('敬请期待')
      }
    },
    // 查看详情
    jumpDetail (item, type) {
      console.log(this.specialType);
      if ((type == 1 && this.seckillType == 0) || (type == 2 && this.specialType == 0)) {
        return this.$message.warning('敬请期待')
      }
      if (type == 1) {
        this.$store.dispatch('saveGoodsId', item.spuId)
        this.$store.dispatch('saveModeType', 1)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "detail",
        });
      } else if (type == 2) {
        if (item.productSpu.productType == 1) {
          this.$store.dispatch('saveGoodsId', item.spuId)
          this.$store.dispatch('saveCategoryTitle', '')
          this.$store.dispatch('saveModeType', 1)
          this.$router.push({
            name: "jdDetail",
          });
        } else {
          this.$store.dispatch('saveGoodsId', item.spuId)
          this.$store.dispatch('saveModeType', 1)
          this.$store.dispatch('saveCategoryTitle', '')
          this.$router.push({
            name: "detail",
          });
        }
      } else {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$router.push({
          name: "groupDetail",
          // query: {
          //   id: item.id,
          // }
        });
      }

    },
    // 获取优惠活动信息
    getSpecial () {
      this.$api.mall.getSpecial().then((res) => {
        console.log(res, '限时特惠');
        if (res.code == 200) {
          if (!res.data) {
            this.specialType = 0
            this.specialList = this.list1
          } else {
            this.specialType = 1
            res.data.countdown = new Date(res.data.endTime).getTime() + 3000
            this.specialInfo = res.data
            this.specialList = !res.data.specialSpus ? this.list1 : res.data.specialSpus
          }
        }
        this.$forceUpdate()
      });
    },
    // 获取秒杀活动信息
    getSeckill () {
      this.$api.mall.getSeckill().then((res) => {
        console.log(res, '限时秒杀');
        if (res.code == 200) {
          if (!res.data || (res.data && res.data.length == 0)) {
            this.seckillList = this.list2
            this.seckillType = 0
          } else {
            this.skillType = 1
            let data = res.data
            data.forEach(item => {
              item.startCountDown = new Date(item.startTimeStamp).getTime() + 3000
              item.endCountDown = new Date(item.endTimeStamp).getTime() + 3000
            });
            this.seckillInfo1 = !res.data[0] ? '' : res.data[0]
            this.seckillInfo2 = !res.data[1] ? '' : res.data[1]

            this.seckillList = !res.data[0].data ? this.list2 : res.data[0].data
          }
        }
        this.$forceUpdate()
        this.$loading().close()
      });
    },
    // 获取拼团活动列表
    getGroup () {
      this.$api.mall.getGroupActivityList().then((res) => {
        if (res.code == 200) {
          if (!res.data) {
            this.groupType = 0
            this.groupList = this.list3
            this.groupTabs = []
          } else {
            this.groupType = 1
            this.groupTabs = res.data
            this.getGroupGoodsList()
          }
        }
        this.$forceUpdate()
      });
    },
    // 获取拼团商品列表
    getGroupGoodsList (type) {
      this.$api.mall.getGroupGoodsList({
        pageNum: 1,
        pageSize: 8,
        groupId: this.groupTabs[this.groupIndex].id
      }).then((res) => {
        if (res.code == 200) {
          this.groupList = !res.rows ? [] : res.rows
        }
        this.$forceUpdate()
        if (type == 1) this.$loading().close()
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.discountModule {
  width: 100%;
  margin-top: 40px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  .module {
    width: 49%;
    border-radius: 10px;
    border: 1px solid #f5f5f5;
    padding: 12px;
    box-sizing: border-box;
    .navBox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title1 {
        font-size: 32px;
        font-weight: bold;
        color: #e01121;
      }
      .title2 {
        font-size: 32px;
        font-weight: bold;
        color: #ef8642;
      }
      .timeBox {
        flex: 1;
        padding: 0 32px 0 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        .box1 {
          width: 170px;
          height: 40px;
          background-color: #ffffff;
          color: #000000;
          padding: 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .time {
            font-size: 16px;
            font-weight: bold;
          }
          .countDown {
            flex: 1;
            margin-left: 12px;
            .word {
              font-size: 12px;
              color: #000000;
              font-weight: bold;
            }
            ::v-deep .number {
              font-size: 12px;
              color: #000000;
              font-weight: bold;
            }
            ::v-deep .head {
              text-align: left;
            }
            ::v-deep .title {
              font-size: 12px;
              color: #000000;
              font-weight: bold;
            }
          }
        }
        .box2 {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #e01121 50%, #ffffff 50%);
        }
        .box2_2 {
          width: 40px;
          height: 40px;
          background: linear-gradient(-45deg, #e01121 50%, #ffffff 50%);
        }
        .box3 {
          width: 170px;
          height: 40px;
          background-color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          .time {
            font-size: 14px;
            font-weight: bold;
          }
          .lable {
            border: 1px solid #999999;
            border-radius: 20px;
            font-size: 12px;
            color: #999999;
            padding: 3px 10px;
            box-sizing: border-box;
            margin-left: 10px;
          }
        }
        .box4 {
          width: 250px;
        }
        .check {
          background-color: #e01121;
          color: #ffffff;
          .countDown {
            .word {
              font-size: 12px;
              color: #ffffff;
              font-weight: bold;
            }
            ::v-deep .number {
              font-size: 12px;
              color: #ffffff;
              font-weight: bold;
            }
            ::v-deep .head {
              text-align: left;
            }
            ::v-deep .title {
              font-size: 12px;
              color: #ffffff;
              font-weight: bold;
            }
          }
          .lable {
            border-color: #fff;
            color: #fff;
          }
        }
      }
      .more {
        display: flex;
        align-items: center;
        .word {
          font-size: 18px;
          font-weight: bold;
          margin-right: 5px;
        }
        .icon {
          width: 16px;
          height: 16px;
          border: 2px solid #000000;
          border-radius: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-icon-arrow-right {
            color: #000000 !important;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }
    }
    .goodBox {
      width: 100%;
      background-color: rgba($color: #ffffff, $alpha: 0.7);
      margin-top: 12px;
      border-radius: 5px;
      overflow: hidden;
      .list {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fill, 33.33%);
        justify-content: space-between;
        padding: 0 5px;
        box-sizing: border-box;

        .item {
          width: 100%;
          padding: 13px 8px;
          box-sizing: border-box;
          .img {
            width: 100%;
            height: 217px;
            border-radius: 8px;
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
          }
          .info {
            width: 100%;
            height: 50px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              width: 100%;
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }
            .box {
              width: 100%;
              display: flex;
              align-items: center;
              .lable {
                width: 60px;
                height: 20px;
                background-image: url("/images/seckill_icon.png");
                background-size: 100%;
                background-repeat: no-repeat;
                line-height: 20px;
                color: #ffffff;
                .txt {
                  display: inline-block;
                  width: 50px;
                  text-align: center;
                }
              }
              .price {
                font-size: 12px;
                color: #ff0000;
                font-weight: bold;
                .txt {
                  font-size: 20px;
                }
              }
              .price2 {
                font-size: 12px;
                color: #999;
                text-decoration: line-through;
              }
            }
          }
        }
      }
    }
  }
  .module1 {
    // 春节
    // background: linear-gradient(175deg, #ffffff 10%, #ec6a6c);
    // 春季
    background: linear-gradient(175deg, #ffffff 10%, #6fcc68);
  }
  .module2 {
    // 春节
    // background: linear-gradient(185deg, #ffffff 10%, #ecb94b);
    // 春季
    background: linear-gradient(175deg, #ffffff 10%, #bbe742);
  }
  .module3 {
    width: 100%;
    // height: 400px;
    // background-color: #F9E3D8;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 40px;
    .top {
      width: 100%;
      height: 70px;
      // background-color: #BB0E0E;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .left {
        width: 300px;
        height: 70px;
        // background-color: #bb0e0e;//春节
        background-color: #05d608; //春季
        border-radius: 10px 11px 0 0;
        text-align: center;
        line-height: 70px;
        font-size: 30px;
        color: #ffffff;
      }

      .right {
        flex: 1;
        height: 62px;
        // background-color: #bb0e0e;//春节
        background-color: #05d608; //春季
        border-radius: 0 15px 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .center {
          width: 30px;
          height: 62px;
          // background-color: #bb0e0e;//春节
          background-color: #05d608; //春季
          padding-bottom: 8px;
          box-sizing: border-box;
          .box {
            width: 30px;
            height: 54px;
            // background: linear-gradient(-119deg, #f9e3d8 50%, #bb0e0e 0);//春节
            background: linear-gradient(-119deg, #d5ffd5 50%, #05d608 0); //春季
          }
        }
        .tabBox {
          width: 100%;
          height: 62px;
          // background-color: #f9e3d8;//春节
          background-color: #d5ffd5; //春季
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 0 10px 0 10px;
          padding: 0 12px;
          box-sizing: border-box;
          overflow: hidden;
          .tabs {
            flex: 1;
            padding: 0 24px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            .tab {
              padding: 0 24px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              .word {
                font-size: 20px;
                font-weight: bold;
                color: #ff0000;
                line-height: 40px;
              }
              .line {
                width: 100px;
                height: 3px;
                border-radius: 5px;
              }
              .line1 {
                background-color: #ff0000;
              }
              .line2 {
                background-color: transparent;
              }
            }
          }
          .more {
            display: flex;
            align-items: center;
            .word {
              font-size: 18px;
              font-weight: bold;
              margin-right: 5px;
            }
            .icon {
              width: 16px;
              height: 16px;
              border: 2px solid #000000;
              border-radius: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              .el-icon-arrow-right {
                color: #000000 !important;
                font-weight: bold;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
    .goods {
      width: 100%;
      // height: 300px;
      // background-color: #f9e3d8;//春节
      background-color: #d5ffd5; //春季
      border-radius: 0 0 wq 10px 10px;
      .out {
        width: 100%;
        height: 100%;
        // background: linear-gradient(180deg, #bb0e0e 10%, #fff4e6);//春节
        background: linear-gradient(180deg, #05d608 10%, #d5ffd5);//春季
        padding: 12px;
        box-sizing: border-box;
        border-radius: 0 10px 10px 10px;
        .list {
          width: 100%;
          height: 100%;
          background-color: #ffffff;
          border-radius: 10px;
          padding: 0 6px;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(auto-fill, 12.5%);
          justify-content: space-between;
          .item {
            width: 100%;
            height: 307px;
            padding: 12px 7px;
            box-sizing: border-box;
            .img {
              width: 100%;
              height: 171px;
              border-radius: 8px;
              box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
            }
            .info {
              width: 100%;
              // height: 50px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .name {
                width: 100%;
                height: 45px;
                font-size: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                word-break: break-all;
              }
              .box1 {
                width: 100%;
                display: flex;
                align-items: center;
                padding: 5px 0 8px;
                box-sizing: border-box;
                .lable1 {
                  width: 34px;
                  background-color: #ff0000;
                  border-radius: 3px;
                  font-size: 14px;
                  color: #ffffff;
                  text-align: center;
                }
                .lable2 {
                  width: 46px;
                  background-color: #ff6f11;
                  border-radius: 3px;
                  font-size: 14px;
                  color: #ffffff;
                  text-align: center;
                  margin-left: 10px;
                }
              }
              .box2 {
                width: 100%;
                height: 32px;
                background-color: #ff0000;
                display: flex;
                align-items: center;
                justify-content: center;
                .price {
                  font-size: 12px;
                  color: #ffffff;
                  font-weight: bold;
                  .txt {
                    font-size: 20px;
                  }
                }
                .price2 {
                  font-size: 12px;
                  color: #ffffff;
                  text-decoration: line-through;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>